import {DOM, pages} from "./variables"
import {setHtmlClasses} from "./helpers/html-classes"
import {pageLoadedChecker} from "./helpers/page-loaded-checker"
import {header} from "./components/header"

const
  animations = {
    smoothScroll: async () => await import('./animations/smooth-scroll')
  },
  helpers = {
    JSLink: () => import('./helpers/js-link'),
    smoothScrollUpdate: () => document.dispatchEvent(new Event('smoothScrollUpdate'))
  },
  pagesScripts = {
    home: () => import('./pages/homepage')
  },
  DOMContentLoadedInit = () => {
    pageLoadedChecker()
    setHtmlClasses()

    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    animations.smoothScroll().then(module => {
      // enables smooth scrolling on the whole site except for landing pages
      module.init(true)
      header()
      // simulated JS click
      if (DOM.AreaLink.length > 0) {
        for (const element of DOM.AreaLink) {
          helpers.JSLink().then(module => module.virtualLink(element))
        }
      }

      // fires dedicated page scripts
      if (pages.home) {
        pagesScripts.home().then(module => {
          module.homepage()
        })
      }
    })
  }

export {DOMContentLoadedInit}

